/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { Box, Typography, makeStyles, Grid } from "@material-ui/core";
import { useSnackbar } from "notistack";
import CompanyHeading from "../../../components/theming/CompanyHeading";
import { ResendEmailLink } from "../../../components/core/registration/ResendEmailLink";
import { useTranslation } from "react-i18next";

const successText = "registration.success.text";

export const RegistrationSuccessPage: React.FC = () => {
  const { t } = useTranslation(["authentication", "common", "snackbars"]);
  const [text, setText] = useState<string>(successText);
  const { enqueueSnackbar } = useSnackbar();
  const classes = useStyles();

  useEffect(() => {
    enqueueSnackbar(t("registration.success.text", { ns: "authentication" }), {
      variant: "success",
    });
  }, []);

  return (
    <Box>
      <Grid item xs={12} md={9}>
        <CompanyHeading>
          {t("registration.success.title", { ns: "authentication" })}
        </CompanyHeading>
        <Typography className={classes.mt}>
          {t(text, { ns: "authentication" })}
        </Typography>
        <ResendEmailLink setText={setText} />
      </Grid>
    </Box>
  );
};

const useStyles = makeStyles(() => ({
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    width: "100%",
    paddingTop: "2%",
  },
  mt: {
    marginTop: 30,
  },
}));
